module.exports = __webpack_public_path__ + "dojo-white-bg.11aksMS6.png";